import React from 'react';
import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { handleTruncatedTextInSmallScreens } from '@utils/responsive';
import { StatusColorType, StatusPropsInterface } from './StatusTypes';
import * as Styled from './StatusStyles';

function Status({ status, isTruncateText = false }: StatusPropsInterface) {
  const description: {
    [key in StatusPropsInterface['status']]: {
      text: string;
      color: StatusColorType;
      icon?: string;
    };
  } = {
    in_progress: {
      text: 'Em andamento',
      color: 'gray',
    },
    pending_route: {
      text: 'Rota pendente',
      color: 'orange',
    },
    done_by_trucker: {
      text: 'Carga entregue',
      color: 'green',
    },
    refused: {
      text: 'Motorista recusou',
      color: 'gray',
      icon: 'remove-user',
    },
    'canceled:trucker': {
      text: 'Canceladas',
      color: 'gray',
      icon: 'remove-user',
    },
    'canceled:company': {
      text: 'Canceladas',
      color: 'gray',
      icon: 'cancel',
    },
    unrecognized: {
      text: 'Não reconhecida',
      color: 'gray',
      icon: 'question',
    },
    done: {
      text: 'Viagem concluida',
      color: 'gray',
      icon: 'one-check',
    },
    'trucker:deposit:fee': {
      text: '',
      color: 'gray',
    },
    'company:nca:manually': {
      text: 'Aguardando motorista',
      color: 'gray',
    },
    'chat:negotiation:automatic': {
      text: 'Aguardando motorista',
      color: 'gray',
    },
    inside_pickup_radius: {
      text: 'Entrou no raio de coleta',
      color: 'gray',
    },
    left_pickup_radius: {
      text: 'Em andamento',
      color: 'gray',
    },
    moving_to_delivery: {
      text: 'Indo para a entrega',
      color: 'gray',
    },
    inside_delivery_radius: {
      text: 'Entrou no raio de entrega',
      color: 'gray',
    },
    left_delivery_radius: {
      text: 'Saiu do raio de entrega',
      color: 'gray',
    },
  };
  const statusShow = description[status] || {};
  let { text } = statusShow;

  if (!text) {
    return null;
  }

  if (isTruncateText) {
    text = handleTruncatedTextInSmallScreens(statusShow.text, 18);
  }

  function handleRenderDescription() {
    if (!statusShow.icon) {
      return (
        <FuelTypography size="caption" weight="bold" color="inherit">
          <Styled.StatusShowWrapper>{text}</Styled.StatusShowWrapper>
        </FuelTypography>
      );
    }

    return (
      <FuelTypography size="caption" weight="bold" color="inherit">
        <Styled.WrapperIcon icon={statusShow.icon}>
          <FuelIcon name={statusShow.icon} iconStyle="filled" />
          {text}
        </Styled.WrapperIcon>
      </FuelTypography>
    );
  }

  return (
    <Styled.WrapperText color={statusShow.color}>
      {handleRenderDescription()}
    </Styled.WrapperText>
  );
}

export default Status;
